import ContactForm from "./ContactForm";
import web from '../src/images/contact.svg'

function Contact() {
  return (
    <>
      <ContactForm
        tagLine="Contact Information"
        imgSrc={web}
        visit="/"
        btnName="Goto Homepage"
        contactinfo="Contact number & Whatsapp"
        number="03091514823"
      />
    </>
  )
}

export default Contact
